import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business DB辞書スキーマレイアウト。配下の /db-dictionary/$schema (index) と /db-dictionary/$schema/$table をOutletで描画する薄いラッパー
 * @graph-connects none
 */
export const Route = createFileRoute('/db-dictionary/$schema')({
  component: DbDictionarySchemaLayout,
});

/** @graph-connects none */
function DbDictionarySchemaLayout() {
  return <Outlet />;
}
